import axios from 'axios';

// Two separate backend servers
const SERVERS = {
    SUMA: {
        label: 'PT. Suma Alpha Indonesia',
        short: 'SAI',
        color: '#10b981',
        baseURL: 'https://accurate.sumasistem.co.id',
    },
    GP: {
        label: 'PT. Gelora Printing',
        short: 'GP',
        color: '#f97316',
        baseURL: 'https://accurate.geloraprinting.co.id',
    },
    SURROUNDING_SYS: {
        label: 'Surrounding System',
        short: 'SYS',
        color: '#10b981',
        baseURL: import.meta.env.VITE_SURSYS_URL || 'http://localhost:3044/api',
    },
    PORTAL: {
        label: 'Portal Gelora Aksara',
        short: 'PORTAL',
        color: '',
        baseURL: 'https://portal.geloraaksara.co.id',
    },
    PROJECT_REPORT: {
        label: 'Project Report',
        short: 'PROJECT_REPORT',
        color: '',
        baseURL: 'https://serproj.geloraaksarapratama.co.id/api',
    },
    HRIS: {
        label: 'HRIS',
        short: 'HRIS',
        color: '',
        baseURL: 'https://hrisgelora.co.id',
    },
    GAPFAMILY: {
        label: 'GAP Family (Produksi)',
        short: 'GAPFAM',
        color: '#7c3aed',
        baseURL: import.meta.env.VITE_GAPFAMILY_URL || 'http://localhost:3005/api/v1',
    },
};


const createClient = (serverKey) => {
    const server = SERVERS[serverKey];
    return axios.create({
        baseURL: server.baseURL,
        timeout: 30000,
        headers: { 'Content-Type': 'application/json' },
    });
};

export const sumaApi = createClient('SUMA');
export const gpApi = createClient('GP');
export const dashboardApi = createClient('PORTAL');
export const projectReportApi = createClient('PROJECT_REPORT');
export const hrisApi = createClient('HRIS');
export const surroundingSys = createClient('SURROUNDING_SYS');
export const gapfamilyApi = createClient('GAPFAMILY');

export const PROJECT_REPORT_BASE_URL = SERVERS.PROJECT_REPORT.baseURL.replace(/\/api\/?$/, '/'); // ditambahkan untuk keperluan Preview PDF
